import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize, map } from 'rxjs';
import { DashboardService } from '../../dashboard.service';
import { DocumentData, InchidereLucrare } from '../../document.interface';
import { DocFinalizationService } from 'src/app/platform/nomenclatoare/document-finalization-types/doc-finalization.service';

@Component({
    selector: 'app-modal-inchidere-lucrare',
    templateUrl: './modal-inchidere-lucrare.component.html',
    styleUrls: ['./modal-inchidere-lucrare.component.scss']
})
export class ModalInchidereLucrareComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    token!: string;
    isLoading: boolean = false;
    helper = helper;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    tipuriRezolutii: { name: string; id: number }[] = [
        // {
        //     name: '--Alegeți--',
        //     id: -1,
        // },
        // {
        //     id: 1,
        //     name: 'favorabil',
        // },
        // {
        //     id: 2,
        //     name: 'invalid',
        // },
        // {
        //     id: 3,
        //     name: 'nefavorabil',
        // },
        // {
        //     id: 4,
        //     name: 'trimis',
        // },
    ];

    form: FormGroup = new FormGroup({
        finalizare_type: new FormControl(-1, Validators.compose([
            Validators.required, Validators.min(0)
        ])),
        observatii: new FormControl(''),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DocumentData,
        private dialogRef: MatDialogRef<ModalInchidereLucrareComponent>,
        private dashboardService: DashboardService,
        private notificationService: NotificationService,
        private docFinalizationService: DocFinalizationService,
    ) { }

    ngOnInit() {
        this.loadTipuriRezolutii();
    }

    closeDialog(): void {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadTipuriRezolutii() {
        this.isLoading = true;

        this.docFinalizationService.getList()
            .pipe(
                finalize(() => { this.isLoading = false; }),
                map((response) => [this.defaultParameter, ...response]),
            )
            .subscribe({
                next: (res) => {
                    this.tipuriRezolutii = res;
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    submitForm() {
        this.isLoading = true;

        const { finalizare_type, observatii } = this.form.value as InchidereLucrare;

        const finalizareCerereData = {
            finalizare_type,
            observatii
        };

        this.dashboardService
            .finalizareDocument(this.data.id_document, finalizareCerereData)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
